import React, { useState, useEffect } from "react";
import {
	IonButtons,
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardTitle,
	IonContent,
	IonHeader,
	IonIcon,
	IonItem,
	IonList,
	IonMenuButton,
	IonNote,
	IonPage,
	IonText,
	IonTitle,
	IonModal,
	IonToolbar,
	IonBadge,
	IonBackButton
} from "@ionic/react";
import { IonButton, useIonAlert } from "@ionic/react";
import { IonCol, IonGrid, IonRow, IonLabel, IonInput } from "@ionic/react";
import {
	add,
	arrowBackOutline,
	closeSharp,
	pencil,
	save,
	trash
} from "ionicons/icons";
import axios from "axios";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import NoDataFound from "../../components/NoDataFound";
import Map from "../../components/Map";
import { Button, Phone } from "../../controls";
import Utils from "../../utils/utils";
import PlusIcon from "../../components/PlusIcon";
import useScreenSize, { BreakPoint } from "../../hooks/useScreenSize";
import useStore from "../../store/store";
import { Date } from "../../controls";
import PropertyListItemRentingDetails from "../../components/PropertyListItemRentingDetails";
import AnimatedPage from "../AnimatedPage";

const PropertyDetails: React.FC = (props: any) => {
	const { t } = useTranslation();
	const size = useScreenSize();
	const [data, setData] = useState<any>(null);
	const [data2, setData2] = useState<any>(null);
	let [description, setDescription] = useState<string>("");
	let [expense, setExpense] = useState("");
	let [rent, setRent] = useState("");
	const [date, setDate] = useState<string>(
		moment().format("YYYY-MM-DDTHH:mm:ssZ")
	);

	const [presentAlert] = useIonAlert();
	const history = useHistory();
	const [isEditRentModelOpen, setIsEditRentModelOpen] = useState(false);
	const [isExpModelOpen, setIsExpModelOpen] = useState(false);
	const [isRentModelOpen, setIsRentModelOpen] = useState(false);
	const [toEditId, setToEditId] = useState("");
	const [expTotal, setExpTotal] = useState(0);
	const [rentTotal, setRentTotal] = useState(0);
	let [error, setError] = useState("");
	let [msg, setMsg] = useState("");
	const [propertyExpanses, setPropertyExpanses] = useState<any[]>([]);
	const [propertyRent, setPropertyRent] = useState<any[]>([]);
	let [isDisabled, setIsDisabled] = useState<boolean>(false);
	const { setIsLoading, token } = useStore((state: any) => state);
	const [newRent, setNewRent] = useState<string>("");
	const [rentApplicationDate, setRentApplicationDate] = useState<string>(
		moment().format("YYYY-MM-DDTHH:mm:ssZ")
	);

	useEffect(() => {
		reload();
	}, []);

	const reload = () => {
		getData();
		getData2();
	};

	const getData = () => {
		const id = props.match.params.propertyId;
		if (!id) return;
		axios
			.get(`${process.env.REACT_APP_API_URL}/properties/${id}`, {
				headers: { rentapp_auth: token }
			})
			.then(res => {
				setData(res.data);
				getTransactions(res.data?._id);
			})
			.catch(err => console.log(err));
	};

	const getData2 = async () => {
		const id = props.match.params.propertyId;
		if (!id) return;
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/transactions/stats/${id}`,
				{},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => setData2(res.data))
			.catch(err => console.log(err));
	};

	const getTransactions = (id: any) => {
		axios
			.get(
				`${process.env.REACT_APP_API_URL}/transactions/property/${id}`,
				{ headers: { rentapp_auth: token } }
			)
			.then(res => {
				let exp = res.data
					?.filter((elem: any) => elem.type === "expense")
					.sort((a: any, b: any) =>
						moment(b.date).diff(moment(a.date))
					);
				setExpTotal(
					exp.reduce(
						(sum: number, current: any) => sum + current.amount,
						0
					)
				);
				setPropertyExpanses(exp);

				let rent = res.data
					?.filter((elem: any) => elem.type === "income")
					.sort((a: any, b: any) =>
						moment(b.date).diff(moment(a.date))
					);
				setRentTotal(
					rent.reduce(
						(sum: number, current: any) => sum + current.amount,
						0
					)
				);
				setPropertyRent(rent);
			})
			.catch(err => console.log(err));
	};

	function handleDelete(id: string) {
		presentAlert({
			header: `${t("sureToDel")}`,
			buttons: [
				{
					text: `${t("cancel")}`,
					role: "cancel"
				},
				{
					text: `${t("yes")}`,
					role: "confirm",
					handler: () => {
						axios
							.delete(
								`${process.env.REACT_APP_API_URL}/transactions/${id}`,
								{ headers: { rentapp_auth: token } }
							)
							.then(res => {
								reload();
							})
							.catch(err => {
								setError(err.response.message);
							});
					}
				}
			]
		});
	}

	const editExp = (id: string) => {
		let elem = propertyExpanses.find((elem: any) => elem._id === id);
		setExpense(elem.amount.toString());
		setDescription(elem.description);
		setDate(moment(elem.date).format("YYYY-MM-DDTHH:mm:ssZ"));
		setToEditId(elem._id);
		setIsExpModelOpen(true);
	};

	const editRent = (id: string) => {
		let elem = propertyRent.find((elem: any) => elem._id === id);
		setRent(elem.amount.toString());
		setDescription(elem.description);
		setDate(moment(elem.date).format("YYYY-MM-DDTHH:mm:ssZ"));
		setToEditId(elem._id);
		setIsRentModelOpen(true);
	};

	const addExpanse = () => {
		if (expense === "" || description === "") {
			setError(`${t("addExpError1")}`);
			return;
		}
		if (!/^[+-]?\d+(\.\d+)?$/.test(expense)) {
			setError(`${t("addAmountError")}`);
			return;
		}

		setIsLoading(true);
		setIsDisabled(true);
		let propertyId = data?._id;

		if (toEditId === "") {
			axios
				.post(
					`${process.env.REACT_APP_API_URL}/transactions`,
					{
						propertyId,
						tenantId: data.tenantId?._id || "",
						description,
						amount: expense,
						type: "expense",
						date: date
					},
					{ headers: { rentapp_auth: token } }
				)
				.then(res => {
					setError("");
					setMsg(`${t("addExpMsg")}`);
					setDescription("");
					setDate(moment().format("YYYY-MM-DDTHH:mm:ssZ"));
					setExpense("");
					setIsExpModelOpen(false);
					reload();
					setIsLoading(false);
					setIsDisabled(false);
				})
				.catch(err => {
					setError(err.response.data);
					setIsLoading(false);
					setIsDisabled(false);
				});
		} else {
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/transactions/${toEditId}`,
					{
						description,
						amount: expense,
						date: date
					},
					{ headers: { rentapp_auth: token } }
				)
				.then(res => {
					setError("");
					setMsg(`${t("addExpMsg")}`);
					setDescription("");
					setDate(moment().format("YYYY-MM-DDTHH:mm:ssZ"));
					setExpense("");
					setIsExpModelOpen(false);
					setToEditId("");
					reload();
					setIsLoading(false);
					setIsDisabled(false);
				})
				.catch(err => {
					setError(err.response.data);
					setIsLoading(false);
					setIsDisabled(false);
				});
		}
		setIsDisabled(false);
	};

	const addRent = () => {
		if (!/^[+-]?\d+(\.\d+)?$/.test(rent)) {
			setError(`${t("addAmountError")}`);
			return;
		}

		if (!data.tenantId._id) {
			setError(`${t("notRentedCantAddRent")}`);
			return;
		}

		setIsDisabled(true);
		setIsLoading(true);
		let propertyId = data?._id;
		if (toEditId === "") {
			axios
				.post(
					`${process.env.REACT_APP_API_URL}/transactions`,
					{
						propertyId,
						tenantId: data.tenantId._id,
						description,
						amount: rent,
						type: "income",
						date: moment().format()
					},
					{ headers: { rentapp_auth: token } }
				)
				.then(res => {
					setError("");
					setMsg(`${t("addRentMsg")}`);
					setDescription("");
					setDate(moment().format("YYYY-MM-DDTHH:mm:ssZ"));
					setRent("");
					setIsRentModelOpen(false);
					reload();
					setIsLoading(false);
					setIsDisabled(false);
				})
				.catch(err => {
					setError(err.response.data);
					setIsLoading(false);
					setIsDisabled(false);
				});
		} else {
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/transactions/${toEditId}`,
					{
						description,
						amount: rent,
						date: moment().format()
					},
					{ headers: { rentapp_auth: token } }
				)
				.then(res => {
					setError("");
					setMsg(`${t("addRentMsg")}`);
					setDescription("");
					setDate(moment().format("YYYY-MM-DDTHH:mm:ssZ"));
					setRent("");
					setIsRentModelOpen(false);
					setToEditId("");
					getData();
					setIsLoading(false);
					setIsDisabled(false);
				})
				.catch(err => {
					setError(err.response.data);
					setIsLoading(false);
					setIsDisabled(false);
				});
		}
	};

	const delProperty = (id: string) => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/properties/${id}`, {
				headers: { rentapp_auth: token }
			})
			.then(res => {
				history.push("/properties");
			})
			.catch(err => console.log(err));
	};

	const editProperty = (id: string) => history.push(`/properties/u/${id}`);

	useEffect(() => {
		setError("");
		setMsg("");
	}, [isExpModelOpen, isRentModelOpen]);

	const clearForm = () => {
		setDescription("");
		setDate(moment().format("YYYY-MM-DDTHH:mm:ssZ"));
		setExpense("");
		setRent("");
		setToEditId("");
	};

	const handleUpdateRent = () => {
		if (!/^[+-]?\d+(\.\d+)?$/.test(newRent)) {
			setError(`${t("addAmountError")}`);
			return;
		}

		if (!data.tenantId._id) {
			setError(`${t("notRentedCantAddRent")}`);
			return;
		}

		setIsDisabled(true);
		setIsLoading(true);
		let propertyId = data?._id;
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/properties/update-rent`,
				{
					propertyId,
					newRent: newRent,
					start: moment(rentApplicationDate).format()
				},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => {
				setError("");
				setMsg(`${t("addRentMsg")}`);
				setNewRent("");
				setDate(moment().format("YYYY-MM-DDTHH:mm:ssZ"));
				setIsEditRentModelOpen(false);
				reload();
				setIsLoading(false);
				setIsDisabled(false);
			})
			.catch(err => {
				setError(err.response.data);
				setIsLoading(false);
				setIsDisabled(false);
			});
	};

	return (
		<>
			{/* Add Expanse Model */}
			<IonModal
				isOpen={isExpModelOpen}
				trigger="open-modal-exp"
				backdropDismiss={false}
			>
				<IonHeader>
					<IonToolbar>
						{toEditId === "" ? (
							<IonTitle>{t("addPropertyExpanse")}</IonTitle>
						) : (
							<IonTitle>{t("editExpanseData")}</IonTitle>
						)}
						<IonButtons slot="end">
							<IonButton
								onClick={() => {
									setIsExpModelOpen(false);
									clearForm();
								}}
							>
								<IonIcon icon={closeSharp} />
							</IonButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>
				<IonContent className="ion-padding ion-text-center">
					<IonItem>
						<IonLabel position="floating">
							{t("addDescription")}
						</IonLabel>
						<IonInput
							placeholder={t("addDescription") || ""}
							value={description}
							onIonInput={(e: any) =>
								setDescription(e.target.value)
							}
							onKeyUp={() => {
								setError("");
								setMsg("");
							}}
						></IonInput>
					</IonItem>
					<br />
					<IonItem>
						<IonLabel position="floating">{t("amount")}</IonLabel>
						<IonInput
							placeholder={t("currencySymbol") || ""}
							type="number"
							value={expense}
							onIonInput={(e: any) => setExpense(e.target.value)}
							onKeyUp={() => {
								setError("");
								setMsg("");
							}}
						></IonInput>
					</IonItem>
					<br />
					<Date
						id="expense-date"
						value={date}
						onChange={(e: any) => setDate(e.target.value)}
					/>
					<br />
					<Button
						text={
							toEditId === "" ? t("addExpanse") : t("saveChanges")
						}
						onClick={addExpanse}
						icon={toEditId === "" ? add : save}
						disabled={isDisabled}
					/>
					<br />
					<IonText color="danger">{error}</IonText>
					<IonText color="success">{msg}</IonText>
				</IonContent>
			</IonModal>

			{/* Add Rent Model */}
			<IonModal
				isOpen={isRentModelOpen}
				trigger="open-modal-rent"
				backdropDismiss={false}
			>
				<IonHeader>
					<IonToolbar>
						{toEditId === "" ? (
							<IonTitle>{t("addPropertyRent")}</IonTitle>
						) : (
							<IonTitle>{t("editRentData")}</IonTitle>
						)}
						<IonButtons slot="end">
							<IonButton
								onClick={() => setIsRentModelOpen(false)}
							>
								<IonIcon icon={closeSharp} />
							</IonButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>
				<IonCardContent className="ion-padding ion-text-center">
					<IonItem>
						<IonLabel position="floating">
							{t("addDescription")}
						</IonLabel>
						<IonInput
							placeholder={t("addDescription") || ""}
							value={description}
							onIonInput={(e: any) =>
								setDescription(e.target.value)
							}
							onKeyUp={() => {
								setError("");
								setMsg("");
							}}
						></IonInput>
					</IonItem>
					<IonItem>
						<IonLabel position="floating">{t("amount")}</IonLabel>
						<IonInput
							placeholder={t("currencySymbol") || ""}
							type="number"
							value={rent}
							onIonChange={(e: any) => setRent(e.target.value)}
							onKeyUp={(e: any) => {
								setError("");
								setMsg("");
							}}
						></IonInput>
					</IonItem>
					<br />
					{/* <Date
						id="rent-date"
						value={date}
						onChange={(e: any) => setDate(e.target.value)}
					/>
					<br /> */}
					<Button
						text={toEditId === "" ? t("addRent") : t("saveChanges")}
						onClick={addRent}
						icon={toEditId === "" ? add : save}
						disabled={isDisabled}
					/>
					<br />
					<IonText color="danger">{error}</IonText>
					<IonText color="success">{msg}</IonText>
				</IonCardContent>
			</IonModal>

			{/* Update rent */}
			<IonModal
				isOpen={isEditRentModelOpen}
				initialBreakpoint={0.4}
				breakpoints={[0, 0.4]}
				onDidDismiss={() => setIsEditRentModelOpen(false)}
			>
				<IonContent className="ion-padding">
					<IonHeader>
						<IonTitle>{t("editRent")}</IonTitle>
					</IonHeader>
					<IonItem style={{ marginTop: 10 }}>
						<IonLabel position="floating">{t("amount")}</IonLabel>
						<IonInput
							placeholder={t("currencySymbol") || ""}
							type="number"
							value={newRent}
							onIonChange={(e: any) => setNewRent(e.target.value)}
							onKeyUp={(e: any) => {
								setError("");
								setMsg("");
							}}
						></IonInput>
					</IonItem>
					<br />
					<Date
						id="rent-application-date"
						value={rentApplicationDate}
						onChange={(e: any) =>
							setRentApplicationDate(e.target.value)
						}
					/>
					<br />
					<IonText color="danger">{error}</IonText>
					<IonButton
						expand="full"
						onClick={handleUpdateRent}
						disabled={isDisabled}
					>
						<IonIcon icon={pencil} slot="start" />
						{t("editRent")}
					</IonButton>
				</IonContent>
			</IonModal>

			<IonPage>
				<AnimatedPage>
					<IonHeader>
						<IonToolbar>
							<IonButtons slot="start">
								<IonMenuButton />
							</IonButtons>
							<IonTitle>{t("propertyDetails")}</IonTitle>
						</IonToolbar>
					</IonHeader>

					<IonContent fullscreen>
						<IonHeader collapse="condense">
							<IonToolbar>
								<IonButtons slot="start">
									<IonBackButton
										text=""
										icon={arrowBackOutline}
										defaultHref="/properties"
										style={{ marginLeft: 10 }}
									/>
								</IonButtons>
								<IonTitle
									size="large"
									style={{ marginLeft: 40 }}
								>
									{t("propertyDetails")}
								</IonTitle>
							</IonToolbar>
						</IonHeader>

						<IonGrid>
							<IonRow>
								<IonCol size-xs="12" size-sm="12" size-md="12">
									<IonCard>
										<IonCardHeader>
											<IonCardTitle>
												{data?.address}
												{data?.city.length > 0
													? `, ${data?.city}`
													: ""}
												{data?.zip.length > 0
													? `, ${data?.zip}`
													: ""}
												{data?.state.length > 0
													? `, ${data?.state}`
													: ""}
											</IonCardTitle>
										</IonCardHeader>
										<IonCardContent
											style={{
												paddingBottom: 0
											}}
										>
											{data?.status === "occupied" && (
												<>
													<h2>
														{t("occupiedBy")}:{" "}
														{data?.tenantId?.name} (
														<Phone
															displayType="text"
															value={
																data?.tenantId
																	?.phone
															}
														/>
														)
													</h2>
													<br />
												</>
											)}
											<PropertyListItemRentingDetails
												elem={data}
												data={data2}
											/>
											<IonRow
												style={{
													float: "right",
													marginBottom: 5
												}}
											>
												<IonButton
													onClick={() =>
														setIsEditRentModelOpen(
															true
														)
													}
												>
													<IonIcon
														icon={pencil}
														slot="start"
													/>
													{t("editRent")}
												</IonButton>
												<IonButton
													onClick={() =>
														editProperty(data?._id)
													}
												>
													<IonIcon
														icon={pencil}
														slot="start"
													/>
													{t("edit")}
												</IonButton>
												<IonButton
													color="danger"
													onClick={() =>
														presentAlert({
															header: `${t(
																"sureToDelProperty"
															)}`,
															buttons: [
																{
																	text: `${t(
																		"cancel"
																	)}`,
																	role: "cancel"
																},
																{
																	text: `${t(
																		"yes"
																	)}`,
																	role: "confirm",
																	handler:
																		() => {
																			delProperty(
																				data?._id
																			);
																		}
																}
															]
														})
													}
												>
													<IonIcon
														slot="start"
														className="trash"
														icon={trash}
													/>{" "}
													{t("delete")}
												</IonButton>
											</IonRow>
										</IonCardContent>
									</IonCard>
								</IonCol>
								<IonCol size="12">
									<IonCard>
										<IonCardHeader
											style={{ paddingBottom: 0 }}
										>
											<IonCardTitle>
												{t("propertyExpanse")} /{" "}
												{t("currencySymbol")}
												{Utils.formatToCurrency(
													expTotal
												)}
												<IonButton
													fill="clear"
													onClick={() => {
														clearForm();
														setIsExpModelOpen(true);
													}}
													id="open-modal-exp"
													style={{
														paddingBottom: 20
													}}
												>
													<PlusIcon />
												</IonButton>
											</IonCardTitle>
										</IonCardHeader>

										{propertyExpanses.length === 0 && (
											<IonCardContent>
												<NoDataFound />
											</IonCardContent>
										)}
										{propertyExpanses.length > 0 && (
											<IonCardContent
												style={{
													width: "100%",
													maxHeight: 350,
													overflowY: "auto",
													overflowX: "auto"
												}}
											>
												{size.screen ===
													BreakPoint.xs ||
												size.screen === BreakPoint.s ? (
													<IonList>
														{propertyExpanses.map(
															elem => (
																<IonItem
																	key={
																		elem._id
																	}
																	className="zero-padding-item"
																>
																	<IonLabel>
																		{
																			elem.description
																		}{" "}
																		<br />
																		<IonNote
																			style={{
																				fontSize: 12
																			}}
																		>
																			{moment(
																				elem.date
																			).format(
																				"DD-MMM-YYYY"
																			)}
																		</IonNote>
																	</IonLabel>
																	<IonLabel>
																		{t(
																			"currencySymbol"
																		)}
																		{Utils.formatToCurrency(
																			elem.amount
																		)}
																		<br />
																		<IonNote
																			style={{
																				fontSize: 12
																			}}
																		>
																			{
																				elem
																					.tenantId
																					?.name
																			}
																		</IonNote>
																	</IonLabel>
																	<IonButtons
																		slot="end"
																		style={{
																			marginLeft: 0,
																			marginRight: 0
																		}}
																	>
																		<IonButton
																			fill="clear"
																			id="open-modal"
																			onClick={() =>
																				editExp(
																					elem?._id
																				)
																			}
																		>
																			<IonIcon
																				icon={
																					pencil
																				}
																				slot="icon-only"
																			/>
																		</IonButton>
																		<IonButton
																			fill="clear"
																			color="danger"
																			onClick={() =>
																				handleDelete(
																					elem?._id
																				)
																			}
																		>
																			<IonIcon
																				icon={
																					trash
																				}
																				slot="icon-only"
																			/>
																		</IonButton>
																	</IonButtons>
																</IonItem>
															)
														)}
													</IonList>
												) : (
													<table
														style={{
															width: "100%",
															overflowX: "auto"
														}}
													>
														<tbody>
															{propertyExpanses.map(
																elem => (
																	<tr
																		key={
																			elem._id
																		}
																	>
																		<td>
																			{
																				elem.description
																			}
																		</td>
																		<td>
																			{moment(
																				elem.date
																			).format(
																				"DD-MMM-YYYY"
																			)}
																		</td>
																		<td>
																			{
																				elem
																					.tenantId
																					?.name
																			}
																		</td>
																		<td className="ion-text-end">
																			{t(
																				"currencySymbol"
																			)}
																			{Utils.formatToCurrency(
																				elem.amount
																			)}
																		</td>

																		<td className="ion-text-end">
																			<IonButton
																				fill="clear"
																				color="dark"
																				id="open-modal"
																				onClick={() =>
																					editExp(
																						elem?._id
																					)
																				}
																			>
																				{t(
																					"edit"
																				)}
																			</IonButton>
																			<IonButton
																				fill="clear"
																				color="danger"
																				onClick={() =>
																					handleDelete(
																						elem?._id
																					)
																				}
																			>
																				{t(
																					"delete"
																				)}
																			</IonButton>
																		</td>
																	</tr>
																)
															)}
														</tbody>
													</table>
												)}
											</IonCardContent>
										)}
									</IonCard>
								</IonCol>
								<IonCol size="12" style={{ marginBottom: 50 }}>
									<IonCard>
										<IonCardHeader
											style={{ paddingBottom: 0 }}
										>
											<IonCardTitle>
												{t("propertyRent")} /{" "}
												{t("currencySymbol")}
												{Utils.formatToCurrency(
													rentTotal
												)}
												<IonButton
													fill="clear"
													onClick={() => {
														clearForm();
														setIsRentModelOpen(
															true
														);
													}}
													id="open-modal-rent"
													style={{
														paddingBottom: 20
													}}
												>
													<PlusIcon />
												</IonButton>
											</IonCardTitle>
										</IonCardHeader>

										{propertyRent.length === 0 && (
											<IonCardContent>
												<NoDataFound />
											</IonCardContent>
										)}
										{propertyRent.length > 0 && (
											<IonCardContent
												style={{
													width: "100%",
													maxHeight: 350,
													overflowY: "auto"
												}}
											>
												{size.screen ===
													BreakPoint.xs ||
												size.screen === BreakPoint.s ? (
													<IonList>
														{propertyRent.map(
															elem => (
																<IonItem
																	key={
																		elem._id
																	}
																>
																	<IonLabel>
																		{
																			elem.description
																		}{" "}
																		<br />
																		<IonNote
																			style={{
																				fontSize: 12
																			}}
																		>
																			{moment(
																				elem.date
																			).format(
																				"DD-MMM-YYYY"
																			)}
																		</IonNote>
																	</IonLabel>
																	<IonLabel>
																		{t(
																			"currencySymbol"
																		)}
																		{Utils.formatToCurrency(
																			elem.amount
																		)}
																		<br />
																		<IonNote
																			style={{
																				fontSize: 12
																			}}
																		>
																			{
																				elem
																					.tenantId
																					?.name
																			}
																		</IonNote>
																	</IonLabel>
																	<IonButtons
																		slot="end"
																		style={{
																			marginLeft: 0,
																			marginRight: 0
																		}}
																	>
																		<IonButton
																			fill="clear"
																			id="open-modal"
																			onClick={() =>
																				editRent(
																					elem?._id
																				)
																			}
																		>
																			<IonIcon
																				icon={
																					pencil
																				}
																				slot="icon-only"
																			/>
																		</IonButton>
																		<IonButton
																			fill="clear"
																			color="danger"
																			onClick={() =>
																				handleDelete(
																					elem?._id
																				)
																			}
																		>
																			<IonIcon
																				icon={
																					trash
																				}
																				slot="icon-only"
																			/>
																		</IonButton>
																	</IonButtons>
																</IonItem>
															)
														)}
													</IonList>
												) : (
													<table
														style={{
															width: "100%",
															overflowX: "auto"
														}}
													>
														<tbody>
															{" "}
															{propertyRent.map(
																elem => (
																	<tr
																		key={
																			elem._id
																		}
																	>
																		<td>
																			{
																				elem.description
																			}
																		</td>
																		<td>
																			{moment(
																				elem.date
																			).format(
																				"DD-MMM-YYYY"
																			)}
																		</td>
																		<td>
																			{
																				elem
																					.tenantId
																					?.name
																			}
																		</td>
																		<td className="ion-text-end">
																			{t(
																				"currencySymbol"
																			)}
																			{Utils.formatToCurrency(
																				elem.amount
																			)}
																		</td>
																		<td className="ion-text-end">
																			<IonButton
																				fill="clear"
																				color="dark"
																				id="open-modal"
																				onClick={() =>
																					editRent(
																						elem?._id
																					)
																				}
																			>
																				{t(
																					"edit"
																				)}
																			</IonButton>
																			<IonButton
																				fill="clear"
																				color="danger"
																				onClick={() =>
																					handleDelete(
																						elem?._id
																					)
																				}
																			>
																				{t(
																					"delete"
																				)}
																			</IonButton>
																		</td>
																	</tr>
																)
															)}
														</tbody>
													</table>
												)}
											</IonCardContent>
										)}
									</IonCard>
								</IonCol>

								{data?.lat && data?.lng && (
									<IonCol size="12">
										<IonCard>
											<IonCardHeader>
												<IonCardTitle>
													{t("mapLocation")}
												</IonCardTitle>
											</IonCardHeader>
											<IonCardContent>
												<Map
													co={[data?.lat, data?.lng]}
													text={data?.address || ""}
												/>
											</IonCardContent>
										</IonCard>
									</IonCol>
								)}
							</IonRow>
						</IonGrid>
					</IonContent>
				</AnimatedPage>
			</IonPage>
		</>
	);
};

export default PropertyDetails;
